module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_complaints", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"PrivacyTitle","data-fox-context":"privacy"},[["textNode",{"text":"Complaints Policy"}]]]]],["div",{"data-fox-alias":"privacyText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/complaints.tpl
// module id = 1210
// module chunks = 4